/**
 * Represents the zeus.apollon_fk_conf.conf.kontakte value object - the Foerderkategorie config
 * json structure
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { Model, type MutationsObject } from '@kp/js-model';

export const SICHTBARKEIT = {
    IMMER: null,
    EINREICHUNG: 'einreichung',
    ABSCHLUSS: 'abschluss',
    NIE: 'nie'
};

export class KontaktConfig extends Model {
    public label: string | null = null;
    public sichtbarkeit: string | null = null;
    public hilfetext: string | null = null;
    public hilfetext_kurz: string | null = null;

    public mutations(): MutationsObject {
        return {
            sichtbarkeit: (val: string | null) => {
                if (val === SICHTBARKEIT.ABSCHLUSS || val === SICHTBARKEIT.EINREICHUNG || val === SICHTBARKEIT.NIE) {
                    return val;
                } else {
                    return null;
                }
            }
        };
    }
}
